import React, { Component } from "react";
import { Segment, Card, Header, Loader } from "semantic-ui-react";

import ProfilCard from "../../components/ProfilCard";
import authenticatedFetch from "../../services/authenticatedFetch";

class SearchResults extends Component {
  state = { results: [], loading: true };

  componentDidMount() {
    this.fetchSearchData();
  }

  fetchSearchData() {
    // Get the search field using the path, to use the proper route for the webservice
    let searchField = this.props.location.pathname.split('/')[1];

	  authenticatedFetch(`${searchField}/${this.props.match.params.term}`).then(data =>
        this.setState({
          results: data
        })
      )
      .then(() =>
        this.state.results.map(result => {
          if (result.buildingName === "Saclay-A") {
            result.buildingName = "Campus de Saclay - Bâtiment Eiffel";
          } else if (result.buildingName === "Saclay-B") {
            result.buildingName = "Campus de Saclay - Bâtiment Bouygues";
          } else if (result.buildingName === "Saclay-S") {
            result.buildingName = "Campus de Saclay - Bâtiment Bréguet";
          }
        })
      )
      .then(() => this.setState({ loading: false }))
      .catch(error => console.error(error));
  }

  render() {
    if (this.state.loading) {
      return <Loader active inline="centered" content="Loading..." />;
    }
    return (
      <div className="container">
        <Segment>
          <Header as="h2">Résultats de la recherche</Header>
          <br />
          <Card.Group centered itemsPerRow={3}>
            {this.state.results.map(user => {
              return (
                <ProfilCard
                  key={user.uid}
                  onClick={() => this.props.history.push(`/profil/${user.uid}`)}
                  picture={user.photoUrl}
                  name={user.displayName}
                  campus={user.buildingName}
                  office={user.signaletiqueOrienteur}
                  mail={user.mail}
                  telPro={user.telpro}
                  mobilePro={user.mobilepro}
                  title={user.title}
                />
              );
            })}
          </Card.Group>
          <br />
        </Segment>
      </div>
    );
  }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/scenes/SearchResults/index.js